<template>
<div></div>
</template>

<script>
export default {
    name: 'ApplePopup',
    computed: {},

    created () {
        this.$store.state.header = false;
        this.$store.commit('SHOW_ONLOAD');
		this.$store.commit('START_LOADING')
    },

    methods: {
    },

}
</script>

<style lang="scss" scoped>

</style>